import { render, staticRenderFns } from "./market.vue?vue&type=template&id=4acf2bf1&scoped=true&"
import script from "./market.vue?vue&type=script&lang=js&"
export * from "./market.vue?vue&type=script&lang=js&"
import style0 from "./market.vue?vue&type=style&index=0&id=4acf2bf1&lang=scss&scoped=true&"
import style1 from "./market.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf2bf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acf2bf1')) {
      api.createRecord('4acf2bf1', component.options)
    } else {
      api.reload('4acf2bf1', component.options)
    }
    module.hot.accept("./market.vue?vue&type=template&id=4acf2bf1&scoped=true&", function () {
      api.rerender('4acf2bf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/market/market.vue"
export default component.exports